<script>
	import { createEventDispatcher } from 'svelte';
	import MarkerPopup from "./MarkerPopup.svelte";
	import { AntPath, antPath } from "leaflet-ant-path";
	const dispatch = createEventDispatcher();
	let eye = true;
    export let routeId;
    export let name;
	let routeLayers;
	let start;
	let retrieved = false;

	function clickEye() {
		eye = !eye;
		if (eye)
		{
			dispatch('show-route', routeLayers);
			dispatch('click-focus', L.latLng(start.getAttribute("lat"), start.getAttribute("lon")));
		}
		else{
			dispatch('hide-route', routeLayers);
		}
			
	}

	function bindPopup(marker, createFn) {
		let popupComponent;
		marker.bindPopup(() => {
			let container = L.DomUtil.create("div");
			popupComponent = createFn(container);
			return container;
		});

		marker.on("popupclose", () => {
			if (popupComponent) {
				let old = popupComponent;
				popupComponent = null;
				// Wait to destroy until after the fadeout completes.
				setTimeout(() => {
					old.$destroy();
				}, 500);
			}
		});
	}

	function createMarker(loc) {
		let count = Math.ceil(Math.random() * 25);
		let name = loc.getElementsByTagName("name")[0];
		let marker = L.marker(
			[loc.getAttribute("lat"), loc.getAttribute("lon")],
			{ loc }
		);
		bindPopup(marker, (m) => {
			let c = new MarkerPopup({
				target: m,
				props: {
					name,
				},
			});

			c.$on("change", ({ detail }) => {
				count = detail;
			});

			return c;
		});
		return marker;
	}
	function createTrack(loc) {
		let start = loc.getElementsByTagNameNS(
			"http://www.topografix.com/GPX/1/1",
			"trkpt"
		)[0];
		let trksegs = loc.getElementsByTagNameNS(
			"http://www.topografix.com/GPX/1/1",
			"trkseg"
		);

		let trackLayers = L.layerGroup();
		for (let j = 0; j < trksegs.length; j++) {
			let trkpts = trksegs[j].getElementsByTagNameNS(
				"http://www.topografix.com/GPX/1/1",
				"trkpt"
			);
			let pointList = [];
			for (let k = 0; k < trkpts.length; k++) {
				pointList.push([
					trkpts[k].getAttribute("lat"),
					trkpts[k].getAttribute("lon"),
				]);
			}
			let routeSeg = L.polyline.antPath(pointList, {
				weight: 5,
				color: "#F3DFA2",
				opacity: 0.65,
				hardwareAccelerated: true,
				pulseColor: "#2F242C",
				dashArray: [10, 60],
				delay: 800,
				reverse: true,
			});
			routeSeg.addTo(trackLayers);
		}
		let name = loc.getElementsByTagNameNS(
			"http://www.topografix.com/GPX/1/1",
			"name"
		)[0].innerHTML;
		let marker = L.marker(
			[loc.getAttribute("lat"), loc.getAttribute("lon")],
			{ loc }
		);

		bindPopup(marker);
		return trackLayers;
	}

	function loadRoute() {
		fetch("https://watertower.tummyacid.net/api/" + routeId, {
			headers: {
				Accept: "application/xml",
			},
		}).then((response) => {
			response.text().then((text) => {
				let parser = new DOMParser();
				let gpx = parser.parseFromString(text, "application/xml");

				let markerLayers = L.layerGroup();
				let lineLayers = L.layerGroup();

				let wpts = gpx.getElementsByTagNameNS(
					"http://www.topografix.com/GPX/1/1",
					"wpt"
				);
				for (let i = 0; i < wpts.length; i++) {
					let m = createMarker(wpts[i]);
					markerLayers.addLayer(m);
				}

				let trks = gpx.getElementsByTagNameNS(
					"http://www.topografix.com/GPX/1/1",
					"trk"
				);
				for (let i = 0; i < trks.length; i++) {
					let trkSegs = createTrack(trks[i]);
					// layerControl.addOverlay(
					// 	trkSegs,
					// 	trks[i].getElementsByTagName("name")[0].innerHTML
					// );
					trkSegs.addTo(lineLayers);
				}
				start = trks[0].getElementsByTagNameNS(
					"http://www.topografix.com/GPX/1/1",
					"trkpt"
				)[0];
				retrieved = true;
				dispatch('click-focus', L.latLng(start.getAttribute("lat"), start.getAttribute("lon")));
				routeLayers = L.layerGroup([markerLayers,lineLayers]);
				dispatch('show-route', routeLayers);
			});
		});
	}
</script>

<style>
	.selected {
		background-opacity: 25%;
		background-color: #DCC;
	}
	div.main {
		background-color: #DCC;
		background-opacity: 15%;
		border-radius: 0.375rem;
		margin: 3px;
		overflow-y:scroll;
		display: inline-table;
      }

	  button:disabled {
		color: #333;
	  }

	button {
		width: 2rem;
		height: 2rem;
		border: 0;
		background-color: transparent;
		transition-property: background-color, background-opacity;
		transition-duration: 250ms;
		border-radius: 0.375rem;
	}

</style>
<div class="main">
	<button id="loadButton" disabled={retrieved} on:click={loadRoute} class:selected={retrieved}><small>{name}</small></button>
	<div class="routeDisplay" hidden={!retrieved}>
		<button type="button" on:click={clickEye} class:selected={eye} title="Show Markers">
			<svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="{eye ? 2 : 1}" viewBox="0 0 24 24" stroke="currentColor">
			{#if eye}
				<path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
			{:else}
				<path d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"></path>
			{/if}
			</svg>
		</button>
	</div>
</div>